import { render, staticRenderFns } from "./groupbyItemList.vue?vue&type=template&id=83651d12&scoped=true&"
import script from "./groupbyItemList.vue?vue&type=script&lang=js&"
export * from "./groupbyItemList.vue?vue&type=script&lang=js&"
import style0 from "./groupbyItemList.vue?vue&type=style&index=0&id=83651d12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83651d12",
  null
  
)

export default component.exports